module.exports = __webpack_public_path__ + "img/ic_star_gray_24px.cf5c9615.png";